import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './navigation/Routes';
import { AuthProvider } from './context/authContext';
import React from 'react';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
